var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useUpdateClientStatusMutation } from '../../../../../application/features/clients/client-api';
import useTranslate from '../../../../../localization/helpers';
var DeactivateClientDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, client = _a.client;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var _c = __read(useUpdateClientStatusMutation(), 2), updateClientStatus = _c[0], _d = _c[1], isLoading = _d.isLoading, isSuccess = _d.isSuccess;
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.deactivateSuccess', 'common.client'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var onSubmit = function () {
        updateClientStatus({ id: client.id, isActive: false });
    };
    return (_jsxs(Dialog, { open: isOpen, children: [_jsx(DialogTitle, { id: 'confirm-dialog-title', children: tWithFunction('actions.deactivateFunction', 'common.client') }), _jsx(DialogContent, { children: _jsxs(DialogContentText, { id: 'confirm-dialog-description', children: [tWithFunction('clients.statusConfirmText', 'common.deactivate'), _jsx("strong", { children: client.name }), "?"] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: 'outlined', color: 'inherit', onClick: onClose, disabled: isLoading, children: translate('actions.cancel') }), _jsx(Button, { variant: 'contained', color: 'warning', onClick: onSubmit, disabled: isLoading, children: translate('actions.confirm') })] })] }));
};
export default DeactivateClientDialog;
